module.exports = __webpack_public_path__ + "static/media/mark_simonson_-_proxima_nova_extrabold-webfont.34c73d43.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/mark_simonson_-_proxima_nova_extrabold-webfont.woff
// module id = 399
// module chunks = 33